<template>
<div>

        <v-row>
            <v-col cols="12" md="8">
                <div id="ag-grid-container-sectors">
                    <ag-grid-vue style="width: 100%; height: 100%;" class="ag-theme-balham" v-if="showGrid"
                        :gridOptions="gridOptions"
                        :groupHeaders="true"
                        @row-double-clicked="(params) => {if(!$props.lockSave) {selectedSector = params.data; editSector = true;}}"
                        :rowHeight="40">
                    </ag-grid-vue>
                </div>
            </v-col>

            <v-col cols="12" md="4" style="position: relative;">

                <div class="basic-site-info">
                    <span><v-icon>mdi-radioactive</v-icon> {{ $props.siteName }}</span>
                </div>

                
                <div class="sectors-info">
                <div class="sector-azimuth">
                    <svg viewBox="0 0 24 24">
                        <g class="sec center"><path d="M12 10a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2" /></g>
                        <template v-for="sector in $props.sectors">
                            <g class="sec" :class="{disabled: sectorDisabled(sector)}" @mouseover="highlightSector(sector.sect_azimuth)" @mouseout="highlightSector(null)" :transform="`rotate(${180 + parseInt(sector.sect_azimuth)} 12 12) scale(1)`"><path d="m12,10 m0,12c-1.95,0 -3.78,-0.56 -5.31,-1.53l3.31,-5a4.037,4.037 0 0 0 4,0l3.31,5a9.903,9.903 0 0 1 -5.31,1.53" /></g>
                            <!-- <g class="sec" :transform="`rotate(${180 + sector.sect_azimuth} 12 12) scale(0.75)`"><path d="m16,15 m0,12c-1.95,0 -3.78,-0.56 -5.31,-1.53l3.31,-5a4.037,4.037 0 0 0 4,0l3.31,5a9.903,9.903 0 0 1 -5.31,1.53" /></g> -->
                        </template>
                    </svg>
                </div>
                </div>


            </v-col>

        </v-row>



    <v-dialog v-model="editSector" max-width="800px" width="80%" persistent>
        <sector-edit v-if="editSector" :sector="selectedSector" @close="onSectorEdit"></sector-edit>
    </v-dialog>

</div>
</template>

<script>
import SectorEdit from "@/components/Sites/SectorEdit";
import { AgGridVue } from "ag-grid-vue";
import "../../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
import "../../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
import { alarmDateFilterParams } from "@/components/Alarms/AlarmFuncs";
export default {
    name: 'Sectors',
    props: ['siteName', 'sectors', 'lockSave'],
    components: {
        'ag-grid-vue': AgGridVue,
        SectorEdit
    },
    data: () => ({
        showGrid: false,
        gridOptions: null,
        editSector: false,
        selectedSector: null,
        highlightedSectorAzimuth: null
    }),

    computed: {
        

    },

    methods: {
        buildAgGrid: function() {
            this.showGrid = false;
            this.gridOptions = {};
            this.gridOptions.rowData = this.$props.sectors;
            this.gridOptions.columnDefs = this.createColumnDefs();

            let self = this;
            this.gridOptions.onGridReady = function(params) {
                self.gridOptions.api.hideOverlay();
                self.gridOptions.api.sizeColumnsToFit();
            }

            this.gridOptions.getRowClass = params => {
                if(params.data.sect_azimuth == self.highlightedSectorAzimuth) {
                    return self.sectorDisabled(params.data) ? 'highlighted-sector-azimuth-row disabled' : 'highlighted-sector-azimuth-row';
                }
            },

            this.gridOptions.getContextMenuItems = function() {
                return [
                    'copy',
                    'copyWithHeaders',
                    'paste',
                    'csvExport',
                    'excelExport'
                ];
            };

            this.gridOptions.defaultColDef = {
                sortable: true,
                filter: true,
                resizable: true
            }
            this.showGrid = true;
        },

        createColumnDefs: function() {
            let columnDefs = [];
            const self = this;
            columnDefs = [
                { 
                    headerName: '', 
                    suppressSizeToFit: true,
                    width: 50, filter: 'text', cellStyle: {'padding-top': '5px', 'text-align': 'left', 'background-color': 'white', 'border-right': 'black solid 1px'},
                    cellRenderer: function(params) {
                        let eElement = document.createElement('div');
                        eElement.innerHTML = `<span class="mdi mdi-pencil-circle sector-action" style="cursor: ${self.$props.lockSave ? 'default' : 'pointer'}; color: ${self.$props.lockSave ? '#E0E0E0' : '#c42111'};  font-size: 20pt;" />`
                        const editButton = eElement.querySelectorAll('.sector-action')[0];
                        editButton.addEventListener('click', function() {
                            event.stopPropagation();
                            if(!self.$props.lockSave) {
                                this.selectedSector = params.data;
                                this.editSector = true;
                            }
                        }.bind(this));
                        return eElement;
                    }.bind(this)
                },
                { 
                    headerName: 'Sector #', 
                    field: 'sect_num', 
                    width: 110, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'Cell ID', 
                    field: 'sect_mscid', 
                    width: 90, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'Azimuth', 
                    field: 'sect_azimuth', 
                    width: 100, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                },
                { 
                    headerName: 'Name', 
                    field: 'sect_name', 
                    width: 140, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                },
                { 
                    headerName: 'On Air Date/Time', 
                    field: 'sect_on_air_time', 
                    width: 160, 
                    filter: 'agDateColumnFilter',
                    filterParams: alarmDateFilterParams,
                    cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: (params) => {
                        return params.data.sect_on_air_time ? TELSA.moment(params.data.sect_on_air_time).format('YYYY-MM-DD HH:mm:ss') : "";
                    }
                },
                { 
                    headerName: 'Decomm Date/Time', 
                    field: 'sect_decomm_time', 
                    width: 160, 
                    filter: 'agDateColumnFilter',
                    filterParams: alarmDateFilterParams,
                    cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: (params) => {
                        return params.data.sect_decomm_time ? TELSA.moment(params.data.sect_decomm_time).format('YYYY-MM-DD HH:mm:ss') : "";
                    }
                },
                { 
                    headerName: 'Remote Latitude',
                    width: 160, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: (params) => {
                        if(params.data.sect_data && params.data.sect_data.remote_position) {
                            return params.data.sect_data && params.data.sect_data.remote_position.lat || ""
                        }
                        return "";
                    }
                },
                { 
                    headerName: 'Remote Longitude',
                    width: 160, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: (params) => {
                        if(params.data.sect_data && params.data.sect_data.remote_position) {
                            return params.data.sect_data && params.data.sect_data.remote_position.lng || ""
                        }
                        return "";
                    }
                },
            ];
            return columnDefs;
        },

        onSectorEdit: function() {
            this.editSector = false;
            this.gridOptions.api.refreshCells();
        },

        highlightSector: function(azimuth) {
            this.highlightedSectorAzimuth = azimuth;
            this.gridOptions.api.redrawRows();
        },

        sectorDisabled: function(sector) {
            if(sector.sect_on_air_time && (TELSA.moment.tz(this.$store.state.batchConfig.timezone) < TELSA.moment(sector.sect_on_air_time))) {
                return true;
            }
            if(sector.sect_decomm_time && (TELSA.moment.tz(this.$store.state.batchConfig.timezone) > TELSA.moment(sector.sect_decomm_time))) {
                return true;
            }
            return false;
        }
    },

    mounted() {
        this.buildAgGrid();
    }

  
};
</script>

<style scoped>

    #ag-grid-container-sectors {
        /* height: 100%; */
        height: calc(100vh - 410px);
    }

    .sectors-info {
        width: 100%;
        height: 100%;
        position: relative;
        background-color: #ffffff;
        z-index: 5;
        text-align: center;
    }

    .sectors-info .sector-azimuth .sec {
        width: 120px;
        fill: #c42111;
        stroke: #000000;
        stroke-width: 0.1px;
        fill-opacity: 0.3;
        cursor: pointer;
    }
    .sectors-info .sector-azimuth .sec.disabled {
        fill: #808080;
    }

    .sectors-info .sector-azimuth .sec:hover {
        fill-opacity: 1;
    }

    .sectors-info .sector-azimuth .sec.center {
        fill-opacity: 1;
    }

    .basic-site-info {
        background-color: #c42111;
        border: #424242 solid 1px;
        border-radius: 5px;
        color: #ffffff;
        padding: 2px 5px 2px 5px;
        position: absolute;
        top: 20px;
        left: 20px;
        z-index: 10;
    }
    .basic-site-info i {
        font-size: 21px;
    }

</style>

<style>

    .highlighted-sector-azimuth-row {
        background-color: #c42111 !important;
        color: #ffffff !important;
    }
    .highlighted-sector-azimuth-row.disabled {
        background-color: #808080 !important;
        color: #ffffff !important;
    }

</style>
